import { useEffect, useState, useRef } from 'react';
import { useDropzone } from 'react-dropzone';

import parse from 'html-react-parser';

import { Company } from '../../classess/company/company';
import { Customer } from '../../classess/customer/customer';
import { UserCompanyCustomer } from '../../classess/userCompanyCustomer/userCompanyCustomer';
import { User } from '../../classess/user/user';
import ProfilePasswordEdit from './ProfilePasswordEdit';
import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    LoadingSection, awaitDelayAsync, checkFile, convertFileAsync, dataTableLanguaje, getDocumentMaxFilesMessage, isUndNullEmp,
    getLanguageObj, getNoImage, getResponse, getRolesType, settings, styles, getUserRoles, handleResponseMessageAsync
} from '../../helpers/main';
import { ProfileService } from '../../services/profile/ProfileService';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, html, icons, images, labels, messages, timers } = settings;

const currentMethod = 'Profile';

export default function Profile({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const isMount = useRef(false);
    const auth = useAuth();
    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    let userRoles = getRolesType();
    userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;

    const dtProfileId = 'dtProfile';
    const dtCompanyCustomersId = 'dtCompanyCustomers';

    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        save: false,
        changePassword: false,
        back: false,
    });

    const [user, setUser] = useState(User?.getClass({}, false));
    const [userBefore, setUserBefore] = useState(User?.getClass({}, false));
    const dataFormLength = User?.minMaxLength(false);

    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageObj: languageObj,
        user: user,
        setUser: setUser,
        dtProfileId: dtProfileId,
        dtProfileRowId: 0,
    });

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
            changePassword: {
                defaultClass: 'btn btn-outline-warning shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnChangePassword',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSave',
            },
        },
        dropzone: {
            logo: {
                id: 'dzLogo',
            },
        },
        icons: {
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
            changePassword: {
                id: 'iconChangePassword',
                defaultClass: icons?.fasFa?.key,
            },
            save: {
                id: 'iconSave',
                defaultClass: icons?.fasFa?.save,
            },
        },
        inputs: {
            department: {
                id: 'inputDepartment',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            email: {
                id: 'inputEmail',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            firstName: {
                id: 'inputFirstName',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            lastName: {
                id: 'inputLastName',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            phoneNumber: {
                id: 'inputPhoneNumber',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            position: {
                id: 'inputPosition',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
        },
        spiners: {
            back: {
                id: 'spBack',
                defaultClass: settings?.react?.html?.spinner?.borderSm,
            },
            changePassword: {
                id: 'spChangePassword',
                defaultClass: settings?.react?.html?.spinner?.borderSm,
            },
            save: {
                id: 'spSave',
                defaultClass: settings?.react?.html?.spinner?.borderSm,
            },
        },
    };

    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        department: '',
        position: '',
    });

    const mainMenuProfileImg = $(`#${html?.controls?.main?.menu?.profile?.img?.id}`);

    const fileObjEmpty = { lastModified: 0, lastModifiedDate: {}, name: '', path: '', preview: '', size: 0, type: '', webkitRelativePath: '', };
    const [file, setFile] = useState(fileObjEmpty);
    const fileTypes = settings?.files?.acceptedTypes?.images.concat([]);
    const { getRootProps, getInputProps, inputRef: dropZoneRef, } = useDropzone({
        accept: settings?.react.dropZone?.imagesAccepted,
        onDrop: async (acceptedFiles) => {
            let response = getResponse({ type: 0 });
            const currentMethod = 'dropZone - onDrop';
            try {
                //#region check files
                if (!isUndNullEmp({ data: acceptedFiles, subMethod: currentMethod })?.result &&
                    acceptedFiles?.length > 0) {
                    if (acceptedFiles?.length <= settings?.files?.profile?.logo?.quantity) {
                        //#region check file
                        const fileObj = acceptedFiles[0] || fileObjEmpty;
                        response = checkFile({
                            type: fileObj.type,
                            size: fileObj.size,
                            allowedTypes: fileTypes,
                            maxSize: settings?.files?.profile?.logo?.maxSize,
                            languageId: languageObj?.id,
                            subMethod: currentMethod
                        });
                        if (!response?.isSuccess || response?.isWarning) {
                            await handleResponseMessageAsync({
                                response,
                                currentMethod,
                                auth,
                                setShowData: undefined,
                                showDataValue: response?.isSuccess,
                                languageId: languageObj?.id
                            });
                            return;
                        }
                        //#endregion check file

                        //#region create url preview
                        //#region profile
                        //fileObj = Object.assign(fileObj, { previw: URL.createObjectURL(fileObj) })
                        fileObj.preview = URL.createObjectURL(fileObj);
                        setFile(fileObj);
                        //#endregion profile
                        mainMenuProfileImg?.attr({
                            src: fileObj?.preview,
                        });
                        //#region profile (main / menu)
                        //#endregion profile (main / menu)
                        //#endregion create url preview

                        //#region convert file (base64url)
                        response = await convertFileAsync.toBase64URL({ file: acceptedFiles[0], subMethod: currentMethod, });
                        if (!response?.isSuccess || response?.isWarning) {
                            await handleResponseMessageAsync({
                                response,
                                currentMethod,
                                auth,
                                setShowData: undefined,
                                showDataValue: response?.isSuccess,
                                languageId: languageObj?.id
                            });
                            return;
                        }

                        setUser({ ...user, urlPicture: response?.result, });
                        //#endregion convert file (base64url)
                    } else {
                        response = getDocumentMaxFilesMessage({
                            maxFiles: settings?.files?.profile?.logo?.quantity,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        if (!response?.isSuccess || response?.isWarning) {
                            await handleResponseMessageAsync({
                                response,
                                currentMethod,
                                auth,
                                setShowData: undefined,
                                showDataValue: response?.isSuccess,
                                languageId: languageObj?.id
                            });
                            return;
                        }
                    }
                }
                //#endregion check files
            } catch (ex) {
                response = getResponse({ type: -1 });
                response.msgText = `Method: ${currentMethod}<br/>`;
                response.msgText += `Error: ${ex?.message}<br/>`;
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: undefined,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        },
        maxFiles: 1,
        //maxSize: 2000,
    });
    //#endregion variables

    //#region methods
    //#region profile
    const editProfile = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'editProfile';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let userData = {};
            let companiesData = [];
            let customersData = [];
            let companyCustomers = [];
            let userCompanyCustomersData = [];
            //#endregion variables

            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region profile (update)
            response = await ProfileService.update({
                auth,
                user,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            userData = response?.result?.user || {};
            setUser(userData);
            setUserBefore(userData);
            companiesData = response?.result?.companies || [];
            customersData = response?.result?.customers || [];
            userCompanyCustomersData = response?.result?.userCompanyCustomers || [];

            //#region company / customer (set)
            $(`#${dtCompanyCustomersId}`)?.DataTable()?.rows()?.clear()?.draw(true);

            if (!userRoles?.isAdmin && !userRoles?.isAnalyst) {
                userCompanyCustomersData?.forEach((ucc) => {
                    const modelUserCompanyCustomer = UserCompanyCustomer?.getClass(ucc, false);
                    const modelCompany = Company?.getClass(companiesData?.filter(({ id, }) => id === modelUserCompanyCustomer?.companyId)[0] || {}, false);
                    const modelCustomer = Customer?.getClass(customersData?.filter(({ id, }) => id === modelUserCompanyCustomer?.customerId)[0] || {}, false);
                    companyCustomers.push({
                        company: {
                            name: modelCompany?.name,
                            rif: modelCompany?.rif,
                        },
                        customer: {
                            name: modelCustomer?.name,
                            rif: modelCustomer?.rif,
                        }
                    });
                });
            } else {
                companiesData?.forEach((company) => {
                    const modelCompany = Company?.getClass(company, false);
                    customersData?.forEach((customer) => {
                        const modelCustomer = Customer?.getClass(customer, false);
                        companyCustomers.push({
                            company: {
                                name: modelCompany?.name,
                                rif: modelCompany?.rif,
                            },
                            customer: {
                                name: modelCustomer?.name,
                                rif: modelCustomer?.rif,
                            }
                        });
                    })
                });
            }
            //#endregion company / customer (set)
            //#endregion profile (update)

            //#region check data
            if (isUndNullEmp({ data: userData, subMethod: currentMethod })?.result) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/>`;
                return;
            }
            //#endregion check data

            //#region set datatable
            if ((!isUndNullEmp({ data: companyCustomers, subMethod: currentMethod })?.result && companyCustomers?.length > 0)) {
                response = setDataInDataTable({
                    companyCustomers: companyCustomers,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
            }
            //#endregion set datatable

            //#region update (user / local)
            response = auth?.updateUser({
                _user: userData,
                _token: auth?.user?.token,
                _role: auth?.user?.role,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion update (user / local)

            //#region update (image / menu)
            mainMenuProfileImg?.attr({
                src: isUndNullEmp({ data: file?.preview, subMethod: currentMethod })?.result ?
                    User?.getPictureFullPath({ picture: userData?.urlPicture, subMethod: currentMethod, })?.result :
                    file?.preview,
            });
            //#endregion update (image / menu)

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const changeProfilePassword = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'changeProfilePassword';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, changePassword: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            setModalObj({
                ...modalObj,
                user: user,
                showModal: true,
            })
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, changePassword: false, showLoading: false }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }
    //#endregion profile

    //#region others
    const getData = async ({
        subMethod = ''
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let userData = {};
            let companiesData = [];
            let customersData = [];
            let companyCustomers = [];
            let userCompanyCustomersData = [];
            //#endregion variables

            //#region datatable (set)
            response = setDataTables({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion datatable (set)

            response = await ProfileService.getByIdWithCompaniesAccess({
                auth,
                id: auth?.user?.id || '',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            userData = response?.result?.user || {};
            setUser(userData);
            setUserBefore(userData);

            const responsePicture = User?.getPictureFullPath({ picture: userData?.urlPicture, subMethod: currentMethod, });
            if (!responsePicture?.isSuccess || responsePicture?.isWarning) return;

            setFile({ ...file, preview: responsePicture?.result, });

            companiesData = response?.result?.companies || [];
            customersData = response?.result?.customers || [];
            userCompanyCustomersData = response?.result?.userCompanyCustomers || [];

            //#region company / customer (set)
            if (!userRoles?.isAdmin && !userRoles?.isAnalyst) {
                userCompanyCustomersData?.forEach((ucc) => {
                    const modelUserCompanyCustomer = UserCompanyCustomer?.getClass(ucc, false);
                    const modelCompany = Company?.getClass(companiesData?.filter(({ id, }) => id === modelUserCompanyCustomer?.companyId)[0] || {}, false);
                    const modelCustomer = Customer?.getClass(customersData?.filter(({ id, }) => id === modelUserCompanyCustomer?.customerId)[0] || {}, false);
                    companyCustomers.push({
                        company: {
                            name: modelCompany?.name,
                            rif: modelCompany?.rif,
                        },
                        customer: {
                            name: modelCustomer?.name,
                            rif: modelCustomer?.rif,
                        }
                    });
                });
            } else {
                companiesData?.forEach((company) => {
                    const modelCompany = Company?.getClass(company, false);
                    customersData?.forEach((customer) => {
                        const modelCustomer = Customer?.getClass(customer, false);
                        companyCustomers.push({
                            company: {
                                name: modelCompany?.name,
                                rif: modelCompany?.rif,
                            },
                            customer: {
                                name: modelCustomer?.name,
                                rif: modelCustomer?.rif,
                            }
                        });
                    })
                });
            }
            //#endregion company / customer (set)

            //#region set datatable
            if ((!isUndNullEmp({ data: companyCustomers, subMethod: currentMethod })?.result && companyCustomers?.length > 0)) {
                response = setDataInDataTable({
                    companyCustomers: companyCustomers,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) {
                    return;
                }
            }
            //#endregion set datatable
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let top = '';
            let collapsedGroups = {};
            const caretRightFa = 'fa fa-fw fa-caret-right fa-lg toggler';
            const caretDownFa = 'fa fa-fw fa-caret-down fa-lg toggler';
            //#endregion variables

            //#region process
            $(`#${dtCompanyCustomersId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.rif?.[languageObj?.id], orderable: false, searchable: false, visible: false, width: '0%', },
                    { title: labels?.company?.[languageObj?.id], className: '', orderable: false, searchable: false, visible: false, width: '0%', },
                    { title: labels?.rif?.[languageObj?.id], orderable: false, searchable: false, width: '15%', },
                    { title: labels?.customer?.[languageObj?.id], className: '', orderable: false, searchable: false, width: '85%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [
                    [1, 'asc'],
                    [3, 'asc']
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                rowGroup: {
                    dataSrc: 1,
                    startRender: function (rows, group, level) {
                        try {
                            let all;

                            if (level === 0) {
                                top = group;
                                all = group;
                            } else {
                                all = top + group;

                                if (!collapsedGroups[top]) {
                                    collapsedGroups[all] = !collapsedGroups[all];
                                    return;
                                }
                            }

                            let collapsed = !collapsedGroups[all];
                            let toggleClass = collapsed ? caretRightFa : caretDownFa;
                            rows.nodes().each(function (r) {
                                r.style.display = collapsed ? 'none' : '';
                            });

                            // Add category name to the <tr>. NOTE: Hardcoded colspan
                            let appenStr = `<td colspan='4'><button class='btn btn-sm btn-outline-default' type='button'>`;
                            appenStr += `<span class='${toggleClass}'></span></button><b>${group} (${rows.count()})</b></td>`;
                            return $(`<tr/>`)
                                .append(appenStr)
                                .attr('data-name', all)
                                .toggleClass('collapsed', collapsed);
                        } catch (ex) {
                            console.error(ex);
                        }
                    },
                },
                searching: false,
            });
            //.buttons().container().appendTo(`#${dtCompanyCustomersId}_wrapper .col-md-6:eq(0)`);

            $(`#${dtCompanyCustomersId} tbody`).on('click', 'tr.dtrg-start', function () {
                var name = $(this).data('name');

                collapsedGroups[name] = !collapsedGroups[name];
                $(`#${dtCompanyCustomersId}`).DataTable().draw(false);
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        companyCustomers = [],
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let rowsDt = [];
            //#endregion variables

            //#region process
            companyCustomers?.forEach((companyCustomer) => {
                rowsDt.push([
                    companyCustomer?.company?.rif || '',
                    companyCustomer?.company?.name || '',
                    companyCustomer?.customer?.rif || '',
                    companyCustomer?.customer?.name || '',
                ]);
            });

            $(`#${dtCompanyCustomersId}`)?.DataTable()?.rows?.add(rowsDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const goToBack = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'goToBack';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, back: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            window.location.href = '/';
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, back: false, showLoading: false }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const pictureMethodsAsync = async ({
        e = {},
        type = 0,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'pictureMethodsAsync';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            if (process?.save) return;

            //#region responsepicture (get)
            response = User?.getPictureFullPath({
                picture: type === -1 ? '' :
                    (type === 2 ? userBefore?.urlPicture : ''),
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            const responsePicture = response;
            //#endregion responsepicture (get)

            //#region process
            switch (type) {
                case -1:
                    setUser({ ...user, urlPicture: '', });
                    setFile(fileObjEmpty);
                    mainMenuProfileImg?.attr({
                        src: responsePicture?.noImage,
                    });
                    dropZoneRef.current.value = '';
                    break;
                case 2:
                    setUser({ ...user, urlPicture: userBefore?.urlPicture, });
                    setFile({ ...file, preview: responsePicture?.result, });
                    mainMenuProfileImg?.attr({
                        src: responsePicture?.result,
                    });
                    break;
                default:
                    break;
            }
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.profile?.profile} process={app?.views?.profile?.profile} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.profile?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.profile?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={40}
                                                hidden={!process?.showLoading}
                                                width={40}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt='profile' style={styles?.cardHeaderLogo} src={images?.icons?.user} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.edit?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.user} mr-1`}></i> {labels?.profile?.[languageObj?.id] || 'Fallback'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <div className='row'>
                                                    <div className='col-12'>

                                                        <form onSubmit={(e) => editProfile({ e: e, subMethod: 'userForm' })}>
                                                            <div className='row justify-content-center mb-4 text-center'>
                                                                <div className='col-12 col-md-4'>
                                                                    <div className='position-relative d-inline-block'>
                                                                        <a href='#userPicture'
                                                                            className='d-inline-block'
                                                                            onClick={(e) => {
                                                                                e?.preventDefault?.();
                                                                                $(`#${controls?.dropzone?.logo?.id}`).trigger('click');
                                                                            }}
                                                                            title={messages?.clickToDefineThePicture?.[languageObj?.id]}>
                                                                            <img alt='userPicture'
                                                                                className='img-thumbnail rounded-circle shadow-sm border-0'
                                                                                src={file?.preview || getNoImage({ processType: 1, subMethod: currentMethod })?.result}
                                                                                style={{ width: '120px', height: '120px', objectFit: 'cover', background: '#f8f9fa' }} />
                                                                        </a>
                                                                        <div className='mt-2'>
                                                                            <h5 className='font-weight-bold text-dark mb-0'>{user?.firstName} {user?.lastName}</h5>
                                                                            <small className='text-muted text-uppercase font-weight-bold'>{user?.department} — {user?.position}</small>
                                                                        </div>
                                                                        <div className='d-flex justify-content-center mt-2'>
                                                                            <button type='button' className='btn btn-link text-primary p-1 mx-1'
                                                                                onClick={(e) => {
                                                                                    e?.preventDefault?.();
                                                                                    if (!process?.save) $(`#${controls?.dropzone?.logo?.id}`).trigger('click');
                                                                                }}
                                                                                title={messages?.clickToDefineThePicture?.[languageObj?.id]}>
                                                                                <i className={icons?.fasFa?.search} />
                                                                            </button>
                                                                            <button type='button' className='btn btn-link text-danger p-1 mx-1'
                                                                                onClick={(e) => pictureMethodsAsync({ e: e, type: -1, subMethod: 'pictureDelete' })}
                                                                                title={messages?.clickToDeleteThePicture?.[languageObj?.id]}>
                                                                                <i className={icons?.trashFarFa} />
                                                                            </button>
                                                                            <button type='button' className='btn btn-link text-info p-1 mx-1'
                                                                                onClick={(e) => pictureMethodsAsync({ e: e, type: 2, subMethod: 'pictureRestore' })}
                                                                                title={messages?.clickToRestoreThePicture?.[languageObj?.id]}>
                                                                                <i className={icons?.undoFasFa} />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='row'>
                                                                <div className='col-12 col-md-6'>
                                                                    <div className='form-group'>
                                                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.firstName?.[languageObj?.id]}
                                                                        </small>
                                                                        <input id={controls?.inputs?.firstName?.id}
                                                                            className={controls?.inputs?.firstName?.defaultClass}
                                                                            maxLength={dataFormLength?.max?.firstName}
                                                                            onChange={(e) => setUser({ ...user, firstName: e?.target?.value })}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, firstName: '' }))}
                                                                            value={user?.firstName || ''}
                                                                            style={{ borderRadius: '5px' }}
                                                                            readOnly={process?.save || process?.showLoading} />
                                                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.firstName)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-6'>
                                                                    <div className='form-group'>
                                                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.lastName?.[languageObj?.id]}
                                                                        </small>
                                                                        <input id={controls?.inputs?.lastName?.id}
                                                                            className={controls?.inputs?.lastName?.defaultClass}
                                                                            maxLength={dataFormLength?.max?.lastName}
                                                                            onChange={(e) => setUser({ ...user, lastName: e?.target?.value })}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, lastName: '' }))}
                                                                            value={user?.lastName || ''}
                                                                            style={{ borderRadius: '5px' }}
                                                                            readOnly={process?.save || process?.showLoading} />
                                                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.lastName)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='row'>
                                                                <div className='col-12 col-md-6'>
                                                                    <div className='form-group'>
                                                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.envelope} mr-1`} /> {labels?.email?.[languageObj?.id]}
                                                                        </small>
                                                                        <input id={controls?.inputs?.email?.id}
                                                                            className={controls?.inputs?.email?.defaultClass}
                                                                            maxLength={dataFormLength?.max?.email}
                                                                            onChange={(e) => setUser({ ...user, email: e?.target?.value })}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, email: '' }))}
                                                                            readOnly
                                                                            style={{ borderRadius: '5px' }}
                                                                            value={user?.email || ''} />
                                                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.email)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-6'>
                                                                    <div className='form-group'>
                                                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.mobileAlt} mr-1`} /> {labels?.phoneNumber?.[languageObj?.id]}
                                                                        </small>
                                                                        <input id={controls?.inputs?.phoneNumber?.id}
                                                                            className={controls?.inputs?.phoneNumber?.defaultClass}
                                                                            maxLength={dataFormLength?.max?.phoneNumber}
                                                                            onChange={(e) => setUser({ ...user, phoneNumber: e?.target?.value })}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, phoneNumber: '' }))}
                                                                            value={user?.phoneNumber || ''}
                                                                            style={{ borderRadius: '5px' }}
                                                                            readOnly={process?.save || process?.showLoading} />
                                                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.phoneNumber)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='row'>
                                                                <div className='col-12 col-md-6'>
                                                                    <div className='form-group'>
                                                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.fasFa?.building} mr-1`} /> {labels?.department?.[languageObj?.id]}
                                                                        </small>
                                                                        <input id={controls?.inputs?.department?.id}
                                                                            className={controls?.inputs?.department?.defaultClass}
                                                                            maxLength={dataFormLength?.max?.department}
                                                                            onChange={(e) => setUser({ ...user, department: e?.target?.value })}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, department: '' }))}
                                                                            style={{ borderRadius: '5px' }}
                                                                            value={user?.department || ''}
                                                                            readOnly={process?.save || process?.showLoading} />
                                                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.department)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-6'>
                                                                    <div className='form-group'>
                                                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={`${icons?.idBadge} mr-1`} /> {labels?.position?.[languageObj?.id]}
                                                                        </small>
                                                                        <input id={controls?.inputs?.position?.id}
                                                                            className={controls?.inputs?.position?.defaultClass}
                                                                            maxLength={dataFormLength?.max?.position}
                                                                            onChange={(e) => setUser({ ...user, position: e?.target?.value })}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, position: '' }))}
                                                                            value={user?.position || ''}
                                                                            style={{ borderRadius: '5px' }}
                                                                            readOnly={process?.save || process?.showLoading} />
                                                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.position)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='row d-flex align-items-center'>
                                                                <div className='col-12'>
                                                                    {!process?.showLoading ?
                                                                        <div hidden
                                                                            {...getRootProps({ className: 'dropzone' })}>
                                                                            <input id={controls?.dropzone?.logo?.id} {...getInputProps()} />
                                                                            <p>Drag 'n' drop some files here, or click to select files</p>
                                                                        </div>
                                                                        :
                                                                        <div></div>
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className='card-footer border-top-0 pb-0 px-0 bg-white'>
                                                                <div className='d-flex flex-wrap justify-content-end w-100' style={{ gap: '8px' }}>
                                                                    <button id={controls?.buttons?.save?.id}
                                                                        className={controls?.buttons?.save?.defaultClass}
                                                                        disabled={process?.save || process?.showLoading}
                                                                        style={{ borderRadius: '5px' }}
                                                                        type='submit'>
                                                                        {!process?.save ? (
                                                                            <i className={controls?.icons?.save?.defaultClass} />
                                                                        ) : (
                                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                                        )} {labels?.save?.[languageObj?.id]}
                                                                    </button>

                                                                    <button id={controls?.buttons?.changePassword?.id}
                                                                        className={controls?.buttons?.changePassword?.defaultClass}
                                                                        disabled={process?.changePassword || process?.showLoading}
                                                                        style={{ borderRadius: '5px' }}
                                                                        onClick={(e) => changeProfilePassword({ e: e, subMethod: e?.currentTarget?.id, })}
                                                                        type='button'>
                                                                        {!process?.changePassword ? (
                                                                            <i className={controls?.icons?.changePassword?.defaultClass} />
                                                                        ) : (
                                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                                        )} {labels?.password?.[languageObj?.id]}
                                                                    </button>

                                                                    <button id={controls?.buttons?.back?.id}
                                                                        className={controls?.buttons?.back?.defaultClass}
                                                                        disabled={process?.back || process?.showLoading}
                                                                        style={{ borderRadius: '5px' }}
                                                                        type='button'
                                                                        onClick={(e) => goToBack({ e: e, subMethod: controls?.buttons?.back?.id })}>
                                                                        {!process?.back ? (
                                                                            <i className={controls?.icons?.back?.defaultClass} />
                                                                        ) : (
                                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                                        )} {labels?.back?.[languageObj?.id]}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </form>

                                                    </div>
                                                </div>
                                                <hr className='my-4' />
                                                <div className='mt-4'>
                                                    <TableIndex tableId={dtCompanyCustomersId} languageObj={languageObj} />
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>

            </div>

            {modalObj?.showModal && (
                <ProfilePasswordEdit modalObj={modalObj}
                    setModalObj={setModalObj}
                    user={user}
                    setUser={setUser} />
            )}
        </div>
    )
}